import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DcSensorValueProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingSolarStatisticsProperties,
  IsNumberValueProperty,
  SolarStatusProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-solar-overlay',
  templateUrl: './solar-overlay.component.html',
  styleUrls: ['./solar-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolarOverlayComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  solarPumps$: Observable<Feature<SolarStatusProperties, never>>;
  solarCollectorTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  solarDhwTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  solarStatistics$: Observable<Feature<HeatingSolarStatisticsProperties, never>>;
  solarRechargeSuppression$: Observable<Feature<SolarStatusProperties, never>>;
  solarCumulativeProduced$: Observable<Feature<IsNumberValueProperty, never>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.solarPumps$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarPumps
    );
    this.solarCollectorTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarCollectorTemperature
    );
    this.solarDhwTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarDhwTemperature
    );
    this.solarStatistics$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarStatistics
    );
    this.solarRechargeSuppression$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarRechargeSuppression
    );
    this.solarCumulativeProduced$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarCumulativeProduced
    );
  }
}
